import CulturePlateWorkflow from './CulturePlateWorkflow'

export default CulturePlateWorkflow
